import { find, forEach, map, set, toPairs } from 'lodash/fp';
import * as React from 'react';

const withMatchMedia = confFn => Component =>
    class WithMatchMedia extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                mediaProps: {},
            };

            this.listeners = [];
        }

        UNSAFE_componentWillMount() {
            this.attach(this.props);
        }

        UNSAFE_componentWillReceiveProps(nextProps) {
            this.attach(nextProps);
        }

        componentWillUnmount() {
            this.detach();
        }

        attach(props) {
            this.detach();
            let nextState = {};
            const conf = confFn(props);
            forEach(([prop, queryConf]) => {
                const matchers = map(
                    ([query, value]) => ({ matcher: window.matchMedia(query), value }),
                    toPairs(queryConf.queries)
                );
                const setter = set(['mediaProps', prop]);
                const getValue = () => (find(m => m.matcher.matches, matchers) || { value: queryConf.default }).value;
                const check = () => this.setState(setter(getValue()));
                nextState = setter(getValue(), nextState);
                forEach(m => {
                    m.matcher.addListener(check);
                    this.listeners.push({ matcher: m.matcher, fn: check });
                }, matchers);
            }, toPairs(conf));

            this.setState(nextState);
        }

        detach() {
            while (this.listeners.length) {
                const listener = this.listeners.pop();
                listener.matcher.removeListener(listener.fn);
            }
        }

        render() {
            return <Component {...this.props} {...this.state.mediaProps} />;
        }
    };

export default withMatchMedia;
